import { apiSlice } from "../api/apiSlice";

export const videoApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getVideos: builder.query({
            query: () => ({
                url: "/videos",
            }),
        }),
        getVideoById: builder.query({
            query: (videoId) => ({
                url: `/videos?id_like=${videoId}`,
            })
        }),
        addVideo: builder.mutation({
            query: (data) => ({
                url: `/videos`,
                method: 'POST',
                body: data
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                // pessimistically cash update
                try {
                    const video = await queryFulfilled;
                    dispatch(apiSlice.util.updateQueryData("getVideos", undefined, (draftTasks) => {
                        draftTasks.push(video.data)
                    }));

                } catch (error) {

                }
            }
        }),
        updateVideo: builder.mutation({
            query: (data) => ({
                url: `/videos/${data.id}`,
                method: 'PATCH',
                body: data
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                // optimistic cash update
                const patchResult = dispatch(apiSlice.util.updateQueryData("getVideos", undefined, (draftTask) => {
                    const draftResult = draftTask.find(video => video.id == arg.id);
                    
                    draftResult.title = arg.title;
                    draftResult.description = arg.description;
                    draftResult.url = arg.url;
                    draftResult.duration = arg.duration;
                    draftResult.views = arg.views
                }));

                try {
                    await queryFulfilled;
                } catch (error) {
                    patchResult.undo()
                }
            }
        }),
        deleteVideo: builder.mutation({
            query: (videoId) => ({
                url: `/videos/${videoId}`,
                method: "DELETE",
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // optimistic cash update
                const patchResult = dispatch(apiSlice.util.updateQueryData("getVideos", undefined, (draftTasks) => {
                    const index = draftTasks.findIndex(video => video.id == arg);
                    draftTasks.splice(index, 1)
                }));

                try {
                    await queryFulfilled;
                } catch (error) {
                    patchResult.undo()
                }
            }
        }),
    }),
});

export const { useGetVideosQuery, useGetVideoByIdQuery, useAddVideoMutation, useUpdateVideoMutation, useDeleteVideoMutation } = videoApi;
